<template>
    <div class="searchModal"
        v-scroll-lock="true">
        <div class="content">
            <Button class="close"
                appearance="secondary"
                prefixIcon="close"
                iconOnly
                @click="$emit('close')">
            </Button>
            <TextField
                v-model="searchPhrase"
                id="search"
                :label="siteContent.searchCreators"
                autofocus
                @input="runSearch"/>
            <div class="userBlock"
                v-if="searchedUsers.length > 0 && !loading">
                <ul class="users">
                    <li class="user"
                        v-for="(user, index) in searchedUsers"
                        :key="index">
                        <Contributor
                            :slug="user.slug"
                            :avatar="user.avatar"
                            :name="user.name"
                            orientation="vertical"
                            size="large">
                        </Contributor>
                    </li>
                </ul>
            </div>
            <div class="userBlock"
                v-if="following.length !== 0 && !loading">
                <Heading :h="2"
                    size="m">
                    {{ siteContent.recentlyFollowed }}
                </Heading>
                <ul class="users">
                    <li class="user"
                        v-for="(user, index) in following"
                        :key="index">
                        <Contributor
                            :slug="user.slug"
                            :avatar="user.avatar"
                            :name="user.name"
                            orientation="vertical"
                            size="large">
                        </Contributor>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import { db } from '@/firebase'

    import Contributor from '@/components/entry/Contributor'

    export default {
        name: 'SearchModal',
            components: {
            Contributor
        },
        data() {
            return {
                searchPhrase: '',
                searchedUsers: [],
                followingList: [],
                following: [],
                loading: true
            }
        },
        methods: {
            handleEscape(e) {
                if (e.key === 'Esc' || e.key === 'Escape') {
                    this.$emit('close')
                }
            },
            async runSearch() {
                try {
                    this.loading = true
                    await db
                        .collection('users')
                        .where('nameTags', 'array-contains', this.searchPhrase.toLowerCase())
                        .limit(3)
                        .onSnapshot(snapshot => {
                            const users = snapshot.docs
                            .map(doc => {
                                return { 
                                    id: doc.id,
                                    ...doc.data()
                                }
                            })

                            this.searchedUsers = users

                            return () => cleanUp()
                    })
                    this.loading = false
                } catch(error) {
                    throw error
                }
            },
            async getFollowingList() {
                try {
                    this.loading = true
                    let followingRef = await db
                        .collection('users')
                        .doc(this.auth.id)
                        .collection('social')
                        .doc('following')
                        .get()

                    this.followingList = followingRef.data()
                    this.loading = false
                } catch(error) {
                    throw error
                }
            },
            async fetchUser(id) {
                try {
                    let userRef = await db
                        .collection('users')
                        .doc(id)
                        .get()

                    this.following.push(userRef.data())
                }
                catch (error) {
                    throw error
                }
            },
            async fetchFollowing() {
                this.loading = true
                await this.getFollowingList()

                let reversedUserArray = this.followingList.users.reverse()

                for(let i = 0; i < 3; i++) {
                    await this.fetchUser(reversedUserArray[i])
                }

                this.loading = false
            }
        },
        async mounted() {
            document.addEventListener('keydown', this.handleEscape)

            if(this.auth.id) {
                this.fetchFollowing()
            }
        },
        destroyed() {
            document.removeEventListener('keydown', this.handleEscape)
        },
        watch: {
            // call again the method if the route changes
            '$route' (to, from) {
                this.$emit('close')
            }
        }
    }
</script>

<style scoped lang="scss">

    .searchModal {
        position: fixed;
        display: flex;
        justify-content: center;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 11;
        backdrop-filter: blur(2rem);

        &::before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: var(--gradient-black-80-black-0-important);
        }
    }

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 48rem;
        width: 100%;
        padding: 4rem 1rem;
        z-index: 1;
    }

    .close {
        margin-bottom: 1.5rem;
    }

    .userBlock {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 2rem 1rem;
    }

    .h2 {
        margin: 0 0 1.5rem 2rem;
    }

    .users {
        width: 100%;
        display: flex;
        margin: 0;
        padding: 0;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
    }

    .user {
        width: 12rem;
        min-width: 12rem;
        list-style: none;
        margin-right: 1rem;
        scroll-snap-align: start;

        &:last-of-type {
            margin: 0;
        }
    }
</style>